import { render, staticRenderFns } from "./authority-letter-print.vue?vue&type=template&id=c8248080&scoped=true&"
import script from "./authority-letter-print.vue?vue&type=script&lang=js&"
export * from "./authority-letter-print.vue?vue&type=script&lang=js&"
import style0 from "./authority-letter-print.vue?vue&type=style&index=0&id=c8248080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8248080",
  null
  
)

export default component.exports